import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=32602738&scoped=true"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"
import style0 from "./Stage.vue?vue&type=style&index=0&id=32602738&prod&lang=scss&scoped=true"
import style1 from "./Stage.vue?vue&type=style&index=1&id=32602738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32602738",
  null
  
)

export default component.exports